<template>
  <DxPopover
    v-if="visible"
    :class="[{
               bgBlack: styleBackgound},
             {'enable-scroll': enableScroll},
             {'popover-arrow-none': hideArrow},
             {'none-padding-two-side' : nonePaddingTwoSide}
    ]"
    :max-height="maxHeight"
    :min-height="minHeight"
    :width="width"
    :visible="visible"
    :target="target"
    :position="position"
    :close-on-outside-click="closeOnOutsideClick"
    @hiding="closePopover"
  >
    <div
      class="content-container"
      @keyup="handleKeyUp"
    >
      <slot
        id="popover"
        name="content"
      />
    </div>
  </DxPopover>
</template>

<script>
import { DxPopover } from "devextreme-vue/popover";
export default {
  name: "MsPopover",
  components: {
    DxPopover,
  },
  props: {
    //ẩn hiện popover
    visible: {
      default: false,
      type: [Boolean],
    },
    width: {
      default: "100",
      type: [String, Number],
    },
    height: {
      default: "auto",
      type: [String, Number],
    },
    maxHeight: {
      default: 382,
      type: [String, Number],
    },
    minHeight: {
      default: 110,
      type: [String, Number],
    },
    // Hiện title hay không
    showTitle: {
      default: false,
      type: Boolean,
    },
    //Vị trí xuất hiện (id thẻ)
    target: {
      type: [HTMLDivElement],
      default: null
    },
    //vị trí tương đối với điểm được chọn (top/botton)
    position: {
      default: "",
      type: [String, Object],
    },
    //nội dung title
    title: {
      default: "",
      type: String,
    },
    closeOnOutsideClick: {
      default: true,
      type: Boolean,
    },
    outside: {
      default: false,
      type: Boolean,
    },
    styleBackgound: {
      default: false,
      type: Boolean,
    },
    enableScroll: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    nonePaddingTwoSide:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {
    let self = this;
    /**
     * Bắt sự kiện click để tắt popover
     * CreatedBy:NTSON2(10/12/2020)
     * */
    // nhviet comment
    // if (this.outside) {
    //   $("*").bind("click", this.clickOutside);
    // }
    // node mới đưa popover ra khỏi div v-bind:class='popover-arrow-none' nên check như thế này để ẩn mũi tên-dvquang2
    if(this.hideArrow){
      this.$nextTick(()=>{
        $(".dx-popover-arrow").addClass("popover-arrow-none");
      })
    }
    if(this.nonePaddingTwoSide){
      this.$nextTick(()=>{
        $(".dx-popup-flex-height").addClass("none-padding-two-side");
      })
    }

  },
  beforeDestroy() {
    $("*").unbind("click", this.clickOutside);
  },
  methods: {
    /**
     * Đóng popover
     * NTSON2(21/01/2021)
     */
    closePopover() {
      this.$emit("onClose", false);
    },

    /**
     * Xử lý sự kiện click ra ngoài
     * CreatedBy:NTSON2(10/12/2020)
     */
    clickOutside(e) {
      if (
        e.target.className == "combobox-item--text w-90" ||
        e.currentTarget.className == "content-area-default" ||
        e.currentTarget.className == "dx-popup-content" ||
        e.currentTarget.className == "vuesax-app-is-ltr" ||
        e.currentTarget.className ==
          "item-icon mi-close-small cursor-pointer" ||
        e.currentTarget.className == "content-area-reduced" ||
        e.target.className == "mi-circle-close m-t-7"
      ) {
        return;
      }
      var currentElement = $(".dx-popup-content").find(e.target);
      var target = "#" + e.target.id;
      var targetParrent = "#" + e.target.parentElement.id;
      // Kiểm tra có ấn vào vị trí gán popover, nếu không phải tắt popover
      if (
        this.target !== target &&
        this.target !== targetParrent &&
        this.outside &&
        currentElement.length == 0
      ) {
        this.closePopover();
      }
    },
    /**
     * Hàm xử lý sự kiện keyup
     * Created by CVCUONG1 13/1/2020
     */
    handleKeyUp(e) {
      if (e.key === "Escape") {
        this.$emit("keyEscape");
      } else if (e.key === "Enter") {
        this.$emit("keyEnter");
      }
    },
  },
};
</script>

<style lang="scss">
.content-container {
  height: 100%;
}
.dx-popover-without-title .dx-popup-content {
  overflow: unset !important;
  padding: 8px !important;
}
.none-padding-two-side .dx-popup-content{
  padding: 0px !important;
}
.enable-scroll .dx-popup-content {
  overflow: auto !important;
}
.dx-popup-wrapper > .dx-overlay-content {
  border: 1px solid #fff;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.175);
  color: var(--text-primary-color);
}
.popover-arrow-none {
  .dx-popover-arrow::after {
    display: none;
  }
}
.dx-popover-arrow::after {
  border: none;
}
#popover {
  overflow: scroll !important;
}
.bgBlack .dx-popup-flex-height .dx-popup-content {
  background-color: #2a2e41;
  border-radius: 3px;
  box-shadow: inset 0 4px 16px rgba(0, 0, 0, 0.24);
  color: #fff;
}
.bgBlack .dx-popup-flex-height .dx-popup-content span {
  color: #fff;
}
.bgBlack .dx-popover-arrow::after {
  background-color: #2a2e41 !important;
}
.popover-arrow-none {
  display: none;
}
</style>
